import React, { useState } from "react";
import Logo from "../../components/common/Logo";
import { sentOtp, verifyOtp, forgotPassword } from "../../lib/forgetPassword";
import { useNavigate } from "react-router-dom";
import LoginPage from "./LoginPage";
import { toast } from "react-toastify";
import { useRef } from "react";

const ForgetPasswordPage = () => {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const inputRefs = useRef([]);

  // 🔹 SEND OTP API
  const handleSendOtp = async () => {
    if (!email) {
      toast.error("Enter email first");
      return;
    }
     const purpose = "FORGET";

    try {
      setLoading(true);

      const res = await sentOtp(email, purpose,);
      console.log("OTP Response:", res);
      if (res.success === true) {
        toast.success("OTP Sent Successfully");
        setStep(2); // 👉 Move to OTP step
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  // 🔹 VERIFY OTP 
  const handleVerifyOtp = async () => {
    const otpValue = otp.join(""); // ✅ convert first

    if (!otpValue) {
      alert("Enter OTP");
      return;
    }

    try {
      setLoading(true);

      const res = await verifyOtp(email, otpValue); // ✅ send string
      console.log("Verify OTP Response:", res);

      if (res.success) {
        alert("OTP Verified Successfully ✅");
        setStep(3);
      } else {
        alert(res.message || "Invalid OTP");
      }
    } catch (error) {
      console.error(error);
      alert("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  // 🔹 RESET PASSWORD API
  const handleResetPassword = async () => {
    if (!newPassword || !confirmPassword) {
      toast.error("Enter password");
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    try {
      setLoading(true);

      const res = await forgotPassword(email, newPassword, confirmPassword);

      if (res.success) {

        toast.success("Password changed successfully");
        //Navigate("/login");
        navigate("/login");
        // reset state
        setEmail("");
        setOtp("");
        setNewPassword("");
        setConfirmPassword("");
      } else {
        alert(res.message || "Failed to reset password");
      }
    } catch (error) {
      console.error(error);
      alert("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  // OTP input handler
  const handleOtpChange = (value, index) => {
    if (!/^\d?$/.test(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // 👉 Move to next input
    if (value && index < otp.length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  return (
    <>
      <title>Forget Password | InstaED</title>

      <main className="h-screen flex items-center justify-center bg-secondary font-sans">

        <div className="absolute top-5 left-4">
          <Logo />
        </div>

        <div className="w-full max-w-[420px] px-4">

          <h1 className="text-[22px] font-semibold mb-6">
            Reset Password
          </h1>

          {/* ✅ STEP 1: EMAIL */}
          {step === 1 && (
            <div className="flex flex-col gap-4">
              <input
                type="text"
                placeholder="Enter your email ID"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full h-[50px] px-4 rounded-lg border border-gray-border bg-white outline-none"
              />

              <button
                onClick={handleSendOtp}
                className="bg-black-600 text-white py-2 rounded-lg"
              >
                Send OTP
              </button>
              <button onClick={() => navigate("/login")}>
                ← Back to Login
              </button>

            </div>
          )}

          {/* ✅ STEP 2: OTP */}
          {step === 2 && (
            <>
              <div className="flex justify-center gap-3 mt-4">
                {otp.map((val, i) => (
                  <input
                    key={i}
                    ref={(el) => (inputRefs.current[i] = el)}
                    value={val}
                    onChange={(e) => handleOtpChange(e.target.value, i)}
                    onKeyDown={(e) => handleKeyDown(e, i)} // backspace handling
                    maxLength={1}
                    className="w-[45px] h-[45px] text-center text-lg rounded-lg border border-gray-border bg-white outline-none"
                  />
                ))}
              </div>

              <p className="text-center mt-4 text-sm">
                Enter OTP sent to your email
              </p>

              <div className="flex justify-center mt-4">
                <button
                  onClick={() => {
                    if (step === 1) {
                      handleSendOtp();
                    } else if (step === 2) {
                      handleVerifyOtp(); // ✅ THIS IS NEW
                    } else if (step === 3) {
                      alert("Call Forget Password API here");
                    }
                  }}
                  className="bg-black-600 text-white px-6 py-2 rounded-lg"
                >
                  {loading
                    ? "Please wait..."
                    : step === 1
                      ? "Send OTP"
                      : step === 2
                        ? "Verify OTP"
                        : "Reset Password"}
                </button>
              </div>
              <div className="flex justify-center mt-4">
                <button onClick={() => navigate("/login")}>
                  ← Back to Login
                </button>
              </div>

            </>
          )}

          {/* ✅ STEP 3: RESET PASSWORD */}
          {step === 3 && (
            <>
              <div className="flex flex-col gap-4">
                <input
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder="Enter new password"
                  className="w-full h-[50px] px-4 rounded-lg border border-gray-border bg-white outline-none"
                />

                <input
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Re-enter new password"
                  className="w-full h-[50px] px-4 rounded-lg border border-gray-border bg-white outline-none"
                />
              </div>

              <div className="flex justify-center mt-6">
                <button
                  onClick={() => {
                    if (step === 1) {
                      handleSendOtp();
                    } else if (step === 2) {
                      handleVerifyOtp();
                    } else if (step === 3) {
                      handleResetPassword(); // ✅ FINAL STEP
                    }
                  }}
                  className="bg-black-600 text-white px-6 py-2 rounded-lg"
                >
                  {loading
                    ? "Please wait..."
                    : step === 1
                      ? "Send OTP"
                      : step === 2
                        ? "Verify OTP"
                        : "Reset Password"}
                </button>
              </div>
              <div className="flex justify-center mt-6">
                <button onClick={() => navigate("/login")}>
                  ← Back to Login
                </button>
              </div>
            </>
          )}

        </div>

        <footer className="absolute bottom-4 text-center text-sm text-gray-border">
          2026 | Terms of Use | Privacy Policy
        </footer>

      </main>
    </>
  );
};

export default ForgetPasswordPage;